import React from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import NotificationsPageRenderer from "../../components/Notifications/NotificationsPageRenderer.tsx";
import Breadcrumbs from "../../components/UI/Breadcrumbs/Breadcrumbs.tsx";
import NewNavImproved from "../../components/Nav/NewNavImproved.tsx";
import BotoneraModern from "../../components/Botonera/BotoneraModern.tsx";
import useNavVisibility from "../../hooks/useNavVisibility.ts";
import { viewAccessRequest } from "../../store/actions";
import styles from "./Solicitudes.module.scss";

const Container = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding-right: 5%;
  padding-left: 5%;
  max-width: 150rem;
  margin: auto;

  @media (max-width: 900px) {
    padding-right: 0;
    padding-left: 0;
  }

  @media (max-width: 600px) {
    padding-right: 0;
    padding-left: 0;
  }
`;

const OverflowContainer = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: auto;
  padding: 2rem;

  @media (max-width: 900px) {
    padding: 0;
    padding-top: 6rem;
}

  @media (max-width: 600px) {
    padding: 0rem;
    padding-top: 6rem;
  }

`;



const NotificationsContainer = styled.div`
  width: 100%;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  overflow: hidden;


  @media (max-width: 600px) {
    border-radius: 0;
    box-shadow: none;
  }
`;

interface SolicitudesPageProps {
  viewAccessRequest: () => void;
}

const SolicitudesPage: React.FC<SolicitudesPageProps> = ({ viewAccessRequest }) => {
  const { ocultarEnMobile, mobileStylesFromParent } = useNavVisibility();

  React.useEffect(() => {
    viewAccessRequest();
  }, [viewAccessRequest]);

  return (
    <Container>
      {!ocultarEnMobile && <NewNavImproved />}
      {ocultarEnMobile && <BotoneraModern mobileStylesFromParent={mobileStylesFromParent} />}
      <OverflowContainer>
        <div className={styles.breadcrumbsContainer}>
          <Breadcrumbs />
        </div>
          <NotificationsContainer>
            <NotificationsPageRenderer />
          </NotificationsContainer>
      </OverflowContainer>
    </Container>
  );
};

const mapStateToProps = (state: any) => ({
  solicitudesList: state.dashboard.solicitudesList,
});

export default connect(mapStateToProps, {
  viewAccessRequest,
})(SolicitudesPage);
